import './TwoColumnLayout.scss';

type TwoColumnLayoutProps = {
  children: JSX.Element;
  rightColumn: JSX.Element;
  gap?: boolean;
};

function TwoColumnLayout({
  children,
  rightColumn,
  gap,
}: TwoColumnLayoutProps): JSX.Element {
  return (
    <div className={'two-column'}>
      <div className={'two-column__left'}>{children}</div>
      <div className={`two-column__right ${gap ? '-gap' : ''}`}>
        {rightColumn}
      </div>
    </div>
  );
}

export default TwoColumnLayout;
